import { render } from "./UsersPreview.vue?vue&type=template&id=5bfbf08b"
import script from "./UsersPreview.vue?vue&type=script&lang=js"
export * from "./UsersPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__